import { apiGetTransactions } from "@lib/api/transaction";
import { UseQueriesProps } from "@lib/types/General";
import { useQuery } from "@tanstack/react-query";

export const useBlockchainTransactionQueries = (props: UseQueriesProps) => {
  const { queryKey, params, id, enabled = true } = props;
  const queryKeys = queryKey || [
    "blockchain-transaction",
    params ? JSON.stringify(params) : id,
  ];
  // const queryClient = useQueryClient();

  const blockchainTransactionsQuery = useQuery({
    queryFn: () => apiGetTransactions(params),
    queryKey: queryKeys,
    enabled: !!params && !!enabled,
  });

  return {
    blockchainTransactionsQuery,
  };
};
